// Queries from Aave Subgraph

import Fetch from './Fetch';
import TokenMeta from '../assets/TokenData/TokenMeta.json';

const URL =
  'https://api.thegraph.com/subgraphs/name/aave/aave-v2-polygon-mumbai';

export const GetMarkets = async () => {
  const query = `
  {
    reserves {
      id 
      symbol
      liquidityRate
      aToken {
        underlyingAssetAddress
        underlyingAssetDecimals
        id
      }
    }
  }`;

  try {
    const dataObj = {};
    const data = await Fetch(query, URL);
    const reserves = data.data.reserves.filter(
      (e) => e.symbol !== 'AAVE' && e.symbol !== 'WMATIC'
    );

    const filterMethod = (e) => {
      for (let i = 0; i < reserves.length; i++) {
        if (e.symbol.toLowerCase().includes(reserves[i].symbol.toLowerCase())) {
          reserves[i].logo = e.logoURI;
        }
        reserves[i].apy = (reserves[i].liquidityRate * 100) / 10 ** 27;
        dataObj[reserves[i].id] = { ...reserves[i] };
      }
    };

    TokenMeta.tokens.forEach(filterMethod);

    return { reserves, reservesObj: dataObj };
  } catch (err) {
    console.log(err);
    return [];
  }
};
